import { supabase } from '../supabaseClient';

const SETTINGS_KEYS = {
  ROUTING: 'routingConfig',
  WHATSAPP: 'whatsappConfig',
  AI_DISPATCH: 'aiDispatchConfig',
  GROK: 'grokConfig',
  EMAIL: 'emailConfig',
  UNIT_SYSTEM: 'unitSystem',
  GPS_INTERVAL: 'gpsIntervalSeconds'
};

export const loadAllSettingsFromDatabase = async (userId) => {
  if (!userId) return null;
  
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('settings')
      .eq('id', userId)
      .single();
    
    if (error) {
      console.error('Error loading settings from database:', error);
      return null;
    }
    
    return data?.settings || {};
  } catch (error) {
    console.error('Error loading settings from database:', error);
    return null;
  }
};

export const saveSettingToDatabase = async (userId, settingKey, settingValue) => {
  if (!userId) return false;
  
  try {
    const { data: existingProfile, error: fetchError } = await supabase
      .from('profiles')
      .select('settings')
      .eq('id', userId)
      .single();
    
    if (fetchError) {
      console.error('Error fetching profile for settings update:', fetchError);
      return false;
    }
    
    const existingSettings = existingProfile?.settings || {};
    const updatedSettings = {
      ...existingSettings,
      [settingKey]: settingValue
    };
    
    const { error: updateError } = await supabase
      .from('profiles')
      .update({ settings: updatedSettings })
      .eq('id', userId);
    
    if (updateError) {
      console.error('Error saving setting to database:', updateError);
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Error saving setting to database:', error);
    return false;
  }
};

export const saveAllSettingsToDatabase = async (userId, settings) => {
  if (!userId) return false;
  
  try {
    const { data: existingProfile, error: fetchError } = await supabase
      .from('profiles')
      .select('settings')
      .eq('id', userId)
      .single();
    
    if (fetchError) {
      console.error('Error fetching profile for settings update:', fetchError);
      return false;
    }
    
    const existingSettings = existingProfile?.settings || {};
    const updatedSettings = {
      ...existingSettings,
      ...settings
    };
    
    const { error: updateError } = await supabase
      .from('profiles')
      .update({ settings: updatedSettings })
      .eq('id', userId);
    
    if (updateError) {
      console.error('Error saving settings to database:', updateError);
      return false;
    }
    
    return true;
  } catch (error) {
    console.error('Error saving settings to database:', error);
    return false;
  }
};

export { SETTINGS_KEYS };

export default {
  SETTINGS_KEYS,
  loadAllSettingsFromDatabase,
  saveSettingToDatabase,
  saveAllSettingsToDatabase
};
